import { Typography } from '@material-ui/core';

export function CampaignAlignmentBadge({ code }: { code: number | undefined }) {
  const n =
    code === undefined || Number.isNaN(Number(code)) ? undefined : Number(code);

  if (n === 0) {
    return (
      <Typography
        component='span'
        variant='caption'
        style={{ fontWeight: 600, color: '#039855', fontSize: 12 }}
      >
        Aligned
      </Typography>
    );
  }
  if (n === 1) {
    return (
      <Typography
        component='span'
        variant='caption'
        style={{ fontWeight: 600, color: '#B42318', fontSize: 12 }}
      >
        Misaligned
      </Typography>
    );
  }

  if (n === -1) {
    return (
      <Typography
        component='span'
        variant='caption'
        style={{ fontWeight: 600, color: '#667085', fontSize: 12 }}
      >
        Unmatched
      </Typography>
    );
  }

  if (n === -2) {
    return (
      <Typography
        component='span'
        variant='caption'
        style={{ fontWeight: 600, color: '#DC6803', fontSize: 12 }}
      >
        Unscored
      </Typography>
    );
  }

  return (
    <Typography
      component='span'
      variant='caption'
      style={{ fontWeight: 600, color: '#B42318', fontSize: 12 }}
    >
      Unmatched
    </Typography>
  );
}
